/** Estado de selección independiente de React y del dispositivo de entrada. */
export interface FranjaSeleccion { inicio: string; fin: string }
export interface CeldaFranja { inicio: string; fin: string }
export interface EstadoSeleccion { fase: 'vacia' | 'fin' | 'fijada'; ancla?: CeldaFranja; franja: FranjaSeleccion | null }
export const seleccionVacia = (): EstadoSeleccion => ({ fase: 'vacia', franja: null });
export const AVISO_OCUPADO = 'Ese tramo no está disponible. Elige otro horario.';
export function franjaDisponible(f: FranjaSeleccion, ocupadas: CeldaFranja[], ahora: number) {
  const a = new Date(f.inicio).getTime(), b = new Date(f.fin).getTime();
  return Number.isFinite(a) && Number.isFinite(b) && a >= ahora && b > a &&
    !ocupadas.some(c => new Date(c.inicio).getTime() < b && new Date(c.fin).getTime() > a);
}
export function rangoEntre(a: CeldaFranja, b: CeldaFranja): FranjaSeleccion {
  return new Date(a.inicio) <= new Date(b.inicio)
    ? { inicio: a.inicio, fin: b.fin } : { inicio: b.inicio, fin: a.fin };
}
export function siguienteSeleccion(estado: EstadoSeleccion, celda: CeldaFranja,
  opciones: { ocupadas: CeldaFranja[]; ahora: number; arrastre?: CeldaFranja }) {
  const nueva = estado.fase !== 'fin' || estado.ancla?.inicio.slice(0, 10) !== celda.inicio.slice(0, 10);
  if (nueva && !opciones.arrastre) {
    if (!franjaDisponible(celda, opciones.ocupadas, opciones.ahora)) {
      return { estado, aviso: AVISO_OCUPADO, cambio: null };
    }
    return {
      estado: { fase: 'fin' as const, ancla: celda, franja: null },
      aviso: null,
      cambio: null,
    };
  }
  const franja = rangoEntre(opciones.arrastre ?? estado.ancla!, celda);
  if (!franjaDisponible(franja, opciones.ocupadas, opciones.ahora)) {
    return { estado, aviso: AVISO_OCUPADO, cambio: null };
  }
  const siguiente: EstadoSeleccion = { fase: 'fijada', ancla: opciones.arrastre ?? estado.ancla, franja };
  return { estado: siguiente, aviso: null, cambio: franja };
}
